import { useUpdateOrgPaymentCancellationPeriodDays } from "@/apiQueries/useUpdateOrgPaymentCancellationPeriodDays";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardEditableNumberForm } from "./CardEditableNumberForm";
import { CardWithToggler } from "./CardWithToggler";
// Default period applied when the toggle is switched from off to on.
const DEFAULT_PERIOD_DAYS = 5;

export const SettingsEnablePaymentCancellation = () => {
  const { organization } = useRedux("organization");
  const currentPeriodDays = organization.data.paymentCancellationPeriodDays ?? 0;

  const { isChecked, isPending, error, handleToggleChange, mutateAsync } = useSettingsToggle({
    currentValue: currentPeriodDays,
    useUpdateMutation: useUpdateOrgPaymentCancellationPeriodDays,
    getNextValue: (current): number => (current === 0 ? DEFAULT_PERIOD_DAYS : 0),
  });

  return (
    <CardWithToggler
      toggleId="payment-cancellation"
      label="Enable automatic payments cancellation"
      note="Select this option to automatically cancel pending payments after a certain time period. Uncompleted payments will not be made once they are canceled, even if the receiver tries to claim funds. Completed payments are always final."
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    >
      {currentPeriodDays ? (
        <CardEditableNumberForm
          inputId="payment-cancellation-period"
          label="Payments Cancellation Period (days)"
          currentValue={currentPeriodDays}
          zeroValueError="Cancellation period cannot be 0"
          isPending={isPending}
          onSubmit={(next) => mutateAsync(next)}
        />
      ) : null}
    </CardWithToggler>
  );
};
